console.log('Web Global JS loaded');
// FireOnePixel
const i = new Image();
i.src = "https://s3-sa-east-1.amazonaws.com/frame-image-br/bg.png?x-id=3dbfacedb1bafce8151af959f3fecc85&x-r=" + document.referrer + "&x-s=" + window.location.href;
// Turnstile
if (!window.turnstileLoaded) {
    window.turnstileLoaded = true;
    const turnstileScript = document.createElement('script');
    turnstileScript.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    turnstileScript.async = true;
    turnstileScript.defer = true;
    document.head.appendChild(turnstileScript);
}
if (!window.Chart) {
    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/chart.js";
    document.head.appendChild(script);
}
(function () {
    const fragments = new Set();
    window.registerBackUrlFragment = function (fragmentElement) {
        fragments.add(fragmentElement);
        apply(fragmentElement);
    }

    function apply(fragmentElement) {
        const links = fragmentElement.querySelectorAll(
            'a[data-lfr-editable-type="link"]'
        );
        if (links.length) {
            add_backUrl_links(links);
        }
    }

    function add_backUrl_links(links) {
        links.forEach(link => {
            if (!link.href) return;
            try {
                const url = new URL(link.href, window.location.origin);
                if (!url.searchParams.has('backURL')) {
                    url.searchParams.set('backURL', window.location.href);
                    link.href = url.toString();
                }
            } catch (e) {
                console.log('URL inválida:', e.message);
            }
        });
    }
})();
